import React from "react";
import PropTypes from "prop-types";
import './embedstyle.css';

const YoutubeEmbed = ({ embedId }) => (
  <div style={{textAlign:"center"}}>
    <div className="video-responsive" >
      <iframe
        style={{marginLeft:"auto",marginRight:"auto",display:"block"}}
        src={`https://www.youtube.com/embed/${embedId}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded youtube"
      />
    </div>
  </div>
);

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired
};

export default YoutubeEmbed;